 
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import GridView from "../../commonComponents/gridView";

const JobInfiniteScrollContainer = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-grid-section car-shop-section car-product-section" filterTagsClass="job-list-header" scrollType="infinite" gridSize={2} />
    </>
  );
};

export default JobInfiniteScrollContainer;
